.intro {
  margin: 0 0 var(--space-3);
  color: var(--text-muted);
}

.legend {
  font-weight: 600;
  margin-bottom: var(--space-2);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  border: 0;
  margin: 0;
  padding: 0;
}

.person {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2);
  border-radius: var(--radius-control);
  cursor: pointer;
}

.person:hover {
  background: var(--surface-sunken);
}

.who {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.email {
  color: var(--text-subtle);
  font-size: var(--font-size-13);
}

.notice {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-3);
  padding: var(--space-2);
  border-radius: var(--radius-control);
  background: var(--surface-sunken);
}

.error {
  margin-top: var(--space-2);
  color: var(--danger-text);
}
